import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Note from '../BuildingBlocks/Note';
import NoStore from './NoStore';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      display: 'default',
    },
  },
  ol: { paddingLeft: theme.spacing(2.5), marginTop: theme.spacing(3) },
  firstInstruction: { marginTop: -theme.spacing(1) },
  instruction: { marginBottom: theme.spacing(1) },
}));

export default function SellerIdNotes() {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item sm={12} md={6}>
        <Note header="How do I find my Amazon Seller ID?" />
        <ol className={classes.ol}>
          <Typography
            className={classes.instruction + ' ' + classes.firstInstruction}
          >
            <li>
              Go to your storefront in Seller Central, or click on '(Your Seller
              Name) Storefront' in any of your product pages
            </li>
          </Typography>
          <Typography className={classes.instruction}>
            <li>In the URL, copy the numbers that appear after "me="</li>
          </Typography>
        </ol>
      </Grid>
      <Grid item sm={12} md={6}>
        <Note header="No Seller ID?" />
        <NoStore />
      </Grid>
    </Grid>
  );
}
